/**
 * Admin location-map read shapes (`GET /admin/map/locations`).
 *
 * Operator-only visual of where Care Professionals, Facilities, and Homecare
 * recipients are. `MAP_PERSONA_KEYS` is the single source of truth for which
 * personas are mappable — the backend validates against it, and the admin app's
 * `MAP_PERSONAS` style table (shape/colour/legend/detail-route) is keyed by the
 * same values, so adding a persona is one coordinated change.
 *
 * v1 returns ALL geocoded points and the admin app filters client-side (instant
 * toggles at pilot scale); server-side filters are a scale follow-up.
 */
import { z } from 'zod';
/** Personas that have a location (operator has none → excluded). */
export const MAP_PERSONA_KEYS = ['caregiver', 'facility', 'homecare'];
export const MapPersonaKeySchema = z.enum(MAP_PERSONA_KEYS);
/** One mappable entity. `id` is the unique map-feature id; `linkId` is the id the
 *  admin detail route uses (= `id` for caregiver/facility; the parent client id
 *  for a homecare recipient, whose detail lives on the client page). */
export const MapLocationPointSchema = z.object({
    persona: MapPersonaKeySchema,
    id: z.string(),
    linkId: z.string(),
    lat: z.number(),
    lng: z.number(),
    label: z.string(),
    /** Persona-specific status enum value, as a string (Caregiver/Facility/Homecare). */
    status: z.string(),
    /** Care-Professional role codes (e.g. ['PSW','RPN']); empty for other personas. */
    roles: z.array(z.string()),
});
export const MapLocationsResponseSchema = z.object({
    points: z.array(MapLocationPointSchema),
});
//# sourceMappingURL=map.schema.js.map